import { z } from "zod";
import { apiClient } from "../client";
import {
  jobPostingSchema,
  jobPostingQueryResponseSchema,
  jobPostingFiltersResponseSchema,
  jobPostingStatsSchema,
  crawlRunSchema,
  previewJobSearchResponseSchema,
} from "./schemas";
import type {
  JobPosting,
  JobPostingQueryRequest,
  JobPostingQueryResponse,
  JobPostingFiltersResponse,
  JobPostingStats,
  CrawlRun,
  PreviewJobSearchRequest,
  PreviewJobSearchResponse,
  ImportJobPostingsRequest,
} from "./types";

export async function getJobPostings(
  request: JobPostingQueryRequest
): Promise<JobPostingQueryResponse> {
  const response = await apiClient
    .post("job-postings/query", { json: request })
    .json<JobPostingQueryResponse>();
  return jobPostingQueryResponseSchema.parse(response);
}

export async function getJobPosting(id: number): Promise<JobPosting> {
  const response = await apiClient
    .get(`job-postings/${id}`)
    .json<JobPosting>();
  return jobPostingSchema.parse(response);
}

export async function getJobPostingFilters(): Promise<JobPostingFiltersResponse> {
  const response = await apiClient
    .get("job-postings/filters")
    .json<JobPostingFiltersResponse>();
  return jobPostingFiltersResponseSchema.parse(response);
}

export async function getJobPostingStats(): Promise<JobPostingStats> {
  const response = await apiClient
    .get("job-postings/stats")
    .json<JobPostingStats>();
  return jobPostingStatsSchema.parse(response);
}

export async function getCrawlRuns(
  count: number = 20
): Promise<CrawlRun[]> {
  const response = await apiClient
    .get("job-postings/crawl-runs", { searchParams: { count } })
    .json<CrawlRun[]>();
  return z.array(crawlRunSchema).parse(response);
}

export async function previewJobSearch(
  data: PreviewJobSearchRequest
): Promise<PreviewJobSearchResponse> {
  const response = await apiClient
    .post("job-postings/search/preview", { json: data })
    .json<PreviewJobSearchResponse>();
  return previewJobSearchResponseSchema.parse(response);
}

export async function importJobPostings(
  data: ImportJobPostingsRequest
): Promise<CrawlRun> {
  const response = await apiClient
    .post("job-postings/search/import", { json: data })
    .json<CrawlRun>();
  return crawlRunSchema.parse(response);
}
